import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { LogOut, UserRound, FolderOpen } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { homeFor } from "@/lib/access";

export const PublicHeader = () => {
  const { auth, member, session, logout } = useApp();
  const nav = useNavigate();
  const out = async () => { await logout(); toast.success("Signed out"); nav("/"); };
  return (
    <header className="bg-white border-b border-[#E5E7EB]">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 h-16 flex items-center justify-between gap-3">
        <Link to="/" className="flex items-center gap-3 min-w-0" data-testid="public-header-home-link">
          <img src="/images/gamls-logo.png" alt="GAMLS logo" className="w-10 h-10" />
          <div className="font-heading font-extrabold text-lg truncate hidden min-[380px]:block">GAMLS <span className="text-[#E60000]">EventHub</span></div>
        </Link>
        <div className="flex items-center gap-2">
          {auth !== null && <Link to="/resources" className="h-10 px-3 sm:px-4 inline-flex items-center gap-2 rounded-md border border-[#E5E7EB] hover:border-[#E60000] hover:text-[#E60000] text-sm font-semibold transition-colors" data-testid="header-resources-button" aria-label="Resources" title="Resources"><FolderOpen className="w-4 h-4" /><span className="hidden min-[420px]:inline">Resources</span></Link>}
          {member ? (
            <>
              <Link to="/my" className="h-10 px-3 inline-flex items-center gap-2 rounded-md border border-[#E5E7EB] hover:border-[#E60000] text-sm font-semibold transition-colors" data-testid="header-my-eventhub-link"><UserRound className="w-4 h-4" /><span className="hidden sm:inline">My EventHub</span></Link>
              <button onClick={out} className="h-10 px-3 inline-flex items-center gap-2 rounded-md bg-[#111] hover:bg-[#E60000] text-white text-sm font-semibold transition-colors" data-testid="header-member-logout"><LogOut className="w-4 h-4" /><span className="hidden sm:inline">Sign out</span></button>
            </>
          ) : auth?.kind === "staff" ? (
            <>
              <Link to={session ? homeFor(session) : "/change-password"} className="h-10 px-4 inline-flex items-center rounded-md border border-[#E5E7EB] hover:border-[#E60000] text-sm font-semibold transition-colors" data-testid="home-signin-button">Open dashboard</Link>
              <button onClick={out} className="h-10 px-3 inline-flex items-center gap-2 rounded-md bg-[#111] hover:bg-[#E60000] text-white text-sm font-semibold transition-colors" data-testid="header-staff-logout"><LogOut className="w-4 h-4" /><span className="hidden sm:inline">Sign out</span></button>
            </>
          ) : auth === null ? null : (
            <>
              <Link to="/login" className="h-10 px-4 sm:px-5 inline-flex items-center rounded-md bg-[#E60000] hover:bg-[#CC0000] text-white text-sm font-semibold whitespace-nowrap transition-colors" data-testid="home-login-button">Login</Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
};
